import { useEffect, useState } from "react";
import { getViewportValues } from "@/lib/viewport-polyfill";

/**
 * React hook for accessing dynamic viewport values with polyfill support
 * @returns {Object} Viewport values and polyfill status
 */
export function useViewportPolyfill() {
  const [viewport, setViewport] = useState(() => getViewportValues());

  useEffect(() => {
    const updateViewport = () => {
      setViewport(getViewportValues());
    };

    // Listen for viewport changes
    window.addEventListener("resize", updateViewport);
    window.addEventListener("orientationchange", updateViewport);

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", updateViewport);
    }

    return () => {
      window.removeEventListener("resize", updateViewport);
      window.removeEventListener("orientationchange", updateViewport);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener("resize", updateViewport);
      }
    };
  }, []);

  return viewport;
}

/**
 * Hook to get dynamic viewport height with automatic updates
 * @returns {number} Current dynamic viewport height in pixels
 */
export function useDynamicViewportHeight() {
  const { dvh } = useViewportPolyfill();
  return dvh;
}

/**
 * Hook to get dynamic viewport width with automatic updates
 * @returns {number} Current dynamic viewport width in pixels
 */
export function useDynamicViewportWidth() {
  const { dvw } = useViewportPolyfill();
  return dvw;
}
